import pinkAwning from '../images/awnings/pinkAwning.png';
import purpleAwning from '../images/awnings/purpleAwning.png';
// import orangeAwning from '../images/awnings/orangeAwning.png';
import blueAwning from '../images/awnings/blueAwning.png';
import whiteAwning from '../images/awnings/whiteAwning.png';
import redAwning from '../images/awnings/redAwning.png';
import greenAwning from '../images/awnings/greenAwning.png';
import yellowAwning from '../images/awnings/yellowAwning.png';

const awnings = [
    {
        "color": 'greens',
        "awning": greenAwning,
        "tag": 'greenAwning'
    },
    {
        "color": 'pinks',
        "awning": pinkAwning,
        "tag": 'pinkAwning'
    },
    {
        "color": 'purples',
        "awning": purpleAwning,
        "tag": 'purpleAwning'
    },
    {
        "color": 'blues',
        "awning": blueAwning,
        "tag": 'blueAwning'
    },
    {
        "color": 'reds',
        "awning": redAwning,
        "tag": 'redAwning'
    },
    // {
    //     "color": 'oranges',
    //     "awning": orangeAwning,
    //     "tag": 'orangeAwning'
    // },
    {
        "color": 'yellows',
        "awning": yellowAwning,
        "tag": 'yellowAwning'
    },
    {
        "color": 'whites',
        "awning": whiteAwning,
        "tag": 'whiteAwning'
    },
]

export default awnings;